import styled from '@emotion/styled'
import { MediaQueries, theme } from '@hhgtech/hhg-components/misc'

export const StyledBabyGrowthWrapper = styled.div`
  ${MediaQueries.mbDown} {
    padding-top: 20px;
  }
`

export const StyledBabyGrowthForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const StyledFormControl = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  .error-input input {
    border: 1px solid ${theme.colors.red700};
  }
`

export const StyledRow = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  > div {
    width: 100%;
  }
`
